const base = '/resumes',
    basePath = `pages${base}`;
export default [
    {
        path:`/linkedin/index`,
        name:'linkedinIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/linkedin/index`)), 'linkedinIndex'),
        meta:{
            tit:'领英搜索'
        },
    },
    {
        path:`/local/index`,
        name:'localIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/local/index`)), 'localIndex'),
        meta:{
            tit:'人才库'
        }
    },
    {
        path:`/local/update`,
        name:'localUpdate',
        component:r => require.ensure([], () => r(require(`@/${basePath}/local/update`)), 'localUpdate'),
        meta:{
            tit:'人才批量上传'
        }
    },
    {
        path:`/subscription/index`,
        name:'subscriptionIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/subscription/index`)), 'subscriptionIndex'),
        meta:{
            tit:'人才订阅'
        }
    },
    {
        path:`/resume/index`,
        name:'resumeIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/resume/index`)), 'resumeIndex'),
        meta:{
            tit:'人才详情'
        }
    },
    {
        path:`/resume/edit`,
        name:'resumeEdit',
        component:r => require.ensure([], () => r(require(`@/${basePath}/resume/edit`)), 'resumeEdit'),
        meta:{
            tit:'人才编辑'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/router/resumes.js